import { FlightEventHandler, registerEventHandlerClass } from "./flight"
import isPrimaryLink from "../utils/isPrimaryLink"
import * as L from 'leaflet'
import * as map from '../map'

export default class OwnshipTrail extends FlightEventHandler {
	constructor(flight) {
		super(flight)

		this.layer = L.layerGroup()
		this.layer.addTo(map.getMap())
		this.overlay = map.addOverlay("Drone Trail", this.layer, flight.overlay)
		this.segments = []
	}

	/**
   * Keeps a running state of the aircraft track and returns the next LatLng coordinate when valid
   * 
   * @param {FlightMessage} message The step data for the current flight
   * @returns LatLng or undefined
   */
	processMessage(message, deferUpdate = false) {
		if (message.type === 'SKYLINK_ADV_STATUS' && isPrimaryLink(message)) {
			if (message.data.local.isLead && message.data.remote.protocol.radioStatus != 0 && message.data.remote.position.longitude) {
				const point = [message.data.remote.position.latitude, message.data.remote.position.longitude]
				this.segments.push(point)
				if (!deferUpdate) this.addLatLng(point)
			}
		}
		return
	}

	addLatLng(latLng) {
		if (this.track) {
			this.track.addLatLng(latLng)
		} else {
			this.track = L.polyline([latLng], { color: '#3BADD2', opacity: 0.7 }).addTo(this.layer)
		}
	}

	handleKeyframe(keyframe) {
		if (this.track) this.track.removeFrom(this.layer)
		this.track = null
		this.segments = []

		if (keyframe.droneTrail) {
			for(let i = 0; i < keyframe.droneTrail.length; i += 2) {
				this.segments.push([keyframe.droneTrail[i], keyframe.droneTrail[i + 1]])
			}
		}

		this.track = L.polyline(this.segments, { color: '#3BADD2', opacity: 0.7 }).addTo(this.layer)
	}

	handleFlightStep(entry) {
		this.processMessage(entry)
	}

	cleanup() {
		super.cleanup()
		if (this.track) this.track.removeFrom(this.layer)
		this.layer.removeFrom(map.getMap())
		map.removeOverlay(this.overlay)
	}
}

registerEventHandlerClass(OwnshipTrail)